import { render, staticRenderFns } from "./XInputGroupCurrency16.vue?vue&type=template&id=d8176a6a&"
import script from "./XInputGroupCurrency16.vue?vue&type=script&lang=js&"
export * from "./XInputGroupCurrency16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports